<template>

    <div class="my-6">

        <div class="my-3">
            <ListBoxSelectWithImage :options="typeBusBarMaterial" v-model="form.typeBusBarMaterial"
                placeholder="Select Option" labelMain="Material Type" class="my-3" requires="True" />

            <ListBoxSelectWithImage v-if="form.typeBusBarMaterial == 'Copper'" :options="copperMaterial"
                v-model="form.materialThickness" placeholder="Select Option" class="my-3" labelMain="Material Thickness"
                requires="True" />


            <ListBoxSelectWithImage v-if="form.typeBusBarMaterial == 'Aluminum'" :options="AluminumMaterial"
                v-model="form.materialThickness" placeholder="Select Option" class="my-3" labelMain="Material Thickness"
                requires="True" />

            <ListBoxSelectWithImage :options="bareMetal" v-model="form.bareMetal" placeholder="Select Option"
                labelMain="Bare-Metal Finish" class="my-3" requires="True" />

            <ListBoxSelectWithImage v-if="form.typeBusBarMaterial == 'Copper'" :options="tinPlating"
                v-model="form.tinPlating" placeholder="Select Option" labelMain="Do you require Tin Plating ?"
                class="my-3" requires="True" />

            <div v-if="form.typeBusBarMaterial == 'Other'">
                <BaseTextArea
                    label="Please tell us about the material you require. We can source material as a non-stock request, for additional leadtime and cost. "
                    v-model="form.typeBusBarMaterialOther"
                    tooltip="We can source different material as a non-stock request, for additional leadtime and cost." />

            </div>

            <Alert v-if="form.typeBusBarMaterial == 'Copper'"
                message='*Tin Plating is completed off-site via a third-party supplier. This means there will be additional lead time.'
                class="my-3" />


        </div>

    </div>

</template>

<script setup>
import { inject } from 'vue';

import {
    typeBusBarMaterial, copperMaterial, AluminumMaterial, tinPlating, bareMetal
} from '../../constants/busBar';

import Alert from '../formComponents/Alert.vue';
import BaseTextArea from '../formComponents/BaseTextArea.vue';
import BaseSelect from '../formComponents/BaseSelect.vue';


import ListBoxSelectWithImage from '../formComponents/ListBoxSelectWithImage.vue';


const form = inject('form');

</script>